import _ from 'lodash';
import {GetterTree} from 'vuex';
import {MemberStateConstant} from '../constants';
import LtFramework from 'types/lt/ltFramework';

export const AlertNotificationGetters: GetterTree<LtFramework.IAlertNotificationState, LtFramework.IRootState> = {
	getState: (state: LtFramework.IAlertNotificationState) => {
		return state.alertNotifications;
	},
};

export const ClubGetters: GetterTree<LtFramework.IClubState, LtFramework.IRootState> = {
	getState: (state: LtFramework.IClubState) => {
		return state.club;
	},
};

export const ProfileGetters: GetterTree<LtFramework.IProfileState, LtFramework.IRootState> = {
	getState: (state: LtFramework.IProfileState) => {
		return state.profile;
	},
	getIsValid: (state: LtFramework.IProfileState) => {
		return state && state.profile && state.profile.partyId > 0 && state.profile.memberDetails && state.profile.memberDetails.memberId > 0 && state.profile.memberState !== MemberStateConstant.unauthenticated;
	},
	getMemberId: (state: LtFramework.IProfileState) => {
		if (state.profile.memberDetails != null && typeof state.profile.memberDetails !== 'undefined') {
			return state.profile.memberDetails.memberId;
		} else {
			return null;
		}
	},
};

export const UrlGetters: GetterTree<LtFramework.IUrlState, LtFramework.IRootState> = {
	getGlobalPageDriverUrl: (state: LtFramework.IUrlState) => (section: string, page: string) => {
		if (!section) {
			throw new Error('Section is not defined');
		}

		if (!page) {
			throw new Error('Page is not defined');
		}

		if (!state.url.globalPageDrivers[section]) {
			throw new Error('Section ' + section + ' doesn\'t exist in global page drivers');
		}

		if (!state.url.globalPageDrivers[section][page]) {
			throw new Error('Page ' + page + ' doesn\'t exist in global page drivers');
		}

		const url: string = state.url.globalPageDrivers[section][page];

		return url;
	},
	getState: (state: LtFramework.IUrlState) => {
		return state.url;
	},
	getUrlParameter: (state: LtFramework.IUrlState) => (parameter: string) => {
		const url: string = location.href;
		parameter = parameter.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
		const regexS = '[\\?&]' + parameter + '=([^&#]*)';
		const regex = new RegExp( regexS );
		const results = regex.exec( url );
		return results == null ? null : results[1];
	},
};
